module.exports = "/work-site/img/personType.5599538c.png";